import React from 'react';
import { Tabs, Tooltip } from 'antd';
import CharactersTab from './CharactersTab';
import { RELATIONSHIP_UI_ENABLED } from './featureFlags';

const { TabPane } = Tabs;

interface MetadataCharactersTabProps {
  bookId: string;
  apiBase: string;
  userId: string;
  onOpenMatrixEditor: (chapterGuid?: string) => void;
  onOpenAnalysis: () => void;
  onCloseMatrixEditor?: () => void;
  onCloseAnalysis?: () => void;
  startTourSignal?: number;
  relationshipSummaryCard?: React.ReactNode;
  freeRunAvailable?: boolean;
  analysisLoading?: boolean;
  analysisStatus?: string | null;
  registryRefreshSignal?: number | null;
  registryClearSignal?: number | null;
}

const renderMetadataCharactersTab = ({
  bookId,
  apiBase,
  userId,
  onOpenMatrixEditor,
  onOpenAnalysis,
  onCloseMatrixEditor,
  onCloseAnalysis,
  startTourSignal,
  relationshipSummaryCard,
  freeRunAvailable,
  analysisLoading,
  analysisStatus,
  registryRefreshSignal,
  registryClearSignal,
}: MetadataCharactersTabProps): React.ReactElement | null => {
  if (!RELATIONSHIP_UI_ENABLED) {
    return null;
  }

  const showFreeRunIndicator = freeRunAvailable === true;
  const tabLabel = (
    <span data-testid="tutorial:navigation:characters-tab" style={{ display: 'inline-flex', alignItems: 'center', gap: 8 }}>
      <span>Characters</span>
      {showFreeRunIndicator && (
        <Tooltip title="Free character analysis available">
          <span
            data-testid="characters-free-run-badge"
            aria-label="Free character analysis available"
            style={{
              width: 10,
              height: 10,
              borderRadius: '50%',
              background: '#ff4d4f',
              display: 'inline-block',
              boxShadow: '0 0 0 2px rgba(255, 77, 79, 0.2)',
            }}
          />
        </Tooltip>
      )}
    </span>
  );

  return ( 
    <TabPane
      tab={tabLabel}
      key="characters"
      style={{
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      <CharactersTab
        bookId={bookId}
        apiBase={apiBase}
        userId={userId}
        onOpenMatrixEditor={onOpenMatrixEditor}
        onOpenAnalysis={onOpenAnalysis}
        onCloseMatrixEditor={onCloseMatrixEditor}
        onCloseAnalysis={onCloseAnalysis}
        startTourSignal={startTourSignal}
        relationshipSummaryCard={relationshipSummaryCard}
        analysisLoading={analysisLoading}
        analysisStatus={analysisStatus}
        registryRefreshSignal={registryRefreshSignal ?? undefined}
        registryClearSignal={registryClearSignal ?? undefined}
      />
    </TabPane>
  );
};

export default renderMetadataCharactersTab;
